import { createContext } from 'react';

import { UserContextType } from './UserContext.types';

const initialContext: UserContextType = {
  updateUser: () => null,
  user: {
    country: '',
    email: '',
    firstName: '',
    lastName: '',
    password: '',
  },
};

export const UserContext = createContext(initialContext);
